import React from 'react';
import { Link } from 'react-router';

const TermsOfService = () => {
    return (
        <div id="terms-of-service" className="min-h-screen bg-[#e3daed] py-12 sm:py-16 lg:py-20">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
                {/* Header */}
                <div className="text-center mb-12 lg:mb-16">
                    <h1 className="font-cormorant font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-4">
                        Terms and Conditions
                    </h1>
                    <p className="font-nunito text-sm sm:text-base text-gray-600">
                        Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>

                {/* Content */}
                <div className="space-y-8 sm:space-y-10">
                    {/* Section 1 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            1. Non-Refundable Sessions
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            All sessions are non-refundable. Rescheduling is only possible with at least <span className="font-semibold">24 hours' notice</span> to the therapist.
                        </p>
                    </section>

                    {/* Section 2 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            2. Emergency Rescheduling
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            In case of unavoidable emergencies (e.g., severe illness, death or critical family events), if the client is unable to inform the therapist at least 24 hours in advance, <span className="font-semibold">one session</span> may be rescheduled <span className="font-semibold">as a courtesy</span>, at the therapist's discretion.
                        </p>
                    </section>

                    {/* Section 3 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            3. Missed Sessions
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            If the client is unable to attend the session without prior notice (outside of the emergency exception above), the session will <span className="font-semibold">not</span> be rescheduled or refunded, as the therapist's time is compensated regardless of attendance.
                        </p>
                    </section>

                    {/* Section 4 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            4. Late Arrival Policy
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            The therapist will wait <span className="font-semibold">up to 10 minutes</span> from the scheduled time. If the client does not join within that window, the session will be considered <span className="font-semibold">completed</span>.
                        </p>
                    </section>

                    {/* Section 5 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            5. Internet Connectivity Issues
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            In case of poor internet connection, the therapist will attempt to establish a connection for <span className="font-semibold">up to 10 minutes</span>. If the connection cannot be made, the session will be considered <span className="font-semibold">completed</span>.
                        </p>
                    </section>

                    {/* Section 6 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            6. Therapist's Discretion
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                            The therapist reserves the right to:
                        </p>
                        <ul className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed space-y-2 list-disc list-inside pl-4">
                            <li><span className="font-semibold">Reschedule sessions</span> in case of their own emergency.</li>
                            <li><span className="font-semibold">Refer the client to another professional</span> if the therapeutic relationship is not deemed beneficial, with proper notice.</li>
                        </ul>
                    </section>

                    {/* Section 7 */}
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            7. Client Rights
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            The client's rights and responsibilities are outlined under the <span className="font-semibold">User Consent</span>, which the client agrees to upon booking a session.
                        </p>
                    </section>
                </div>

                {/* Back to Home Button */}
                <div className="mt-12 sm:mt-16 text-center">
                    <Link
                        to="/"
                        className="font-nunito text-base sm:text-lg text-gray-600 hover:text-gray-900 underline underline-offset-4 transition-colors"
                    >
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService; 